import { render, staticRenderFns } from "./facebook.vue?vue&type=template&id=745bd013&scoped=true"
import script from "./facebook.vue?vue&type=script&lang=js"
export * from "./facebook.vue?vue&type=script&lang=js"
import style0 from "./facebook.vue?vue&type=style&index=0&id=745bd013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745bd013",
  null
  
)

export default component.exports